module.exports = __webpack_public_path__ + "static/build-together-venture-914a123d22925f32b7874c7fea8a042b.png";